import { LocationType, SAVED_LOCATION } from '@guryou/core';

export const getCategoryName = (categories, id) => {
  return categories.data.find(cat => cat.id === id)?.name || '';
};

export const getGroupName = (groups, id) => {
  return groups.data.find(grp => grp.id === id)?.name || '';
};

export const getLocationInput = data => {
  const { latitude, longitude, locationType, locationNote, address, url } = data;
  const request = {};

  if (+locationType === LocationType.mapLocation || locationType === SAVED_LOCATION) {
    request.locationType = LocationType.mapLocation;
    request.latitude = +latitude;
    request.longitude = +longitude;
    request.address = address;
  } else if (+locationType === LocationType.plainNote || +locationType === LocationType.onlineLocation) {
    request.locationType = locationType;
    request.locationNote = locationNote;
    request.url = url;
  } else if (+locationType === LocationType.providerLocation) {
    request.locationType = locationType;
  }
  return request;
};
